import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '../store';
import {THUNK_STATUS} from '../../domain/types';

const transcriptionSelector = (state: RootState) => state.transcriptions;

export const selectedTranscriptionSelector = (state:RootState) => transcriptionSelector(state).selectedTranscription;

export const transcribingOriginPathSelector = (state: RootState) => transcriptionSelector(state).transcribingOriginPath;

export const transcriptionsDataSelector = (state: RootState) => transcriptionSelector(state).transcriptions;
export const transcriptionsApiSelector = (state: RootState) => transcriptionSelector(state).api;
export const transcriptionsApiStatusSelector = (state: RootState) => transcriptionsApiSelector(state).status;

export const transcriptionIsLoadingSelector = createSelector([
  transcriptionsApiStatusSelector
], status => status === THUNK_STATUS.pending)

/**
 * Jobs still running server-side. This is what the header pill and the poller hang off — the list
 * itself is the single source of truth for "is anything transcribing right now", so there is no
 * separate flag to drift out of step with it.
 */
export const processingTranscriptionsSelector = createSelector(
  [transcriptionsDataSelector],
  transcriptions => transcriptions.filter(t => t.status === 'processing')
);

export const isTranscribingSelector = createSelector(
  [processingTranscriptionsSelector],
  processing => processing.length > 0
);

/**
 * The only rows that can be downloaded or converted. A `processing` row has `size: 0` and nothing
 * behind its `r2_key`; a `failed` one never will have.
 */
export const completedTranscriptionsSelector = createSelector(
  [transcriptionsDataSelector],
  transcriptions => transcriptions.filter(t => t.status === 'completed')
);
